import { useState } from "react";
import styled from "@emotion/styled";

// Components
import { H3 } from "../../../OC/oc-h";
import FormButton from "../../../ComponentLibrary/input-elements/oc-form-button";
import RadioButton from "../../../ComponentLibrary/input-elements/oc-radio-button";

// Styled Components
const Heading = styled(H3)`
  margin-bottom: 24px;
  margin-top: 14px;
`;

const OptionsForm = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
`;

const OptionsContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  position: relative;
  width: 100%;
  flex-direction: column;
  gap: 32px;
`;

const Option = styled.div`
  grid-row: 1;
`;

const Address = styled.div`
  font-size: 16px;
  width: 100%;
`;

const Title = styled.p`
  font-size: 16px;
  font-weight: 700;
  margin: 0px;
  width: 100%;
  display: inline;
`;

const Body = styled.p`
  font-size: 16px;
  width: 100%;
  margin: 5px 0px 0px 0px;
`;

const ValidatedAddressSuggestionModal = ({
  typedAddress,
  validatedSuggestedAddress,
  closeModal,
  handleAddressChange,
}) => {
  const hasValidatedSuggestion = (!_.isEmpty(validatedSuggestedAddress))
  const [selectedModalAddress, setSelectedModalAddress] = useState((hasValidatedSuggestion) ? validatedSuggestedAddress : typedAddress)

  const handleClick = (event) => {
    event.preventDefault();
    handleAddressChange(selectedModalAddress);
    closeModal && closeModal()
  }

  const onChangeValue = (event) => {
    if (event.target.value == validatedSuggestedAddress.toString()) {
      setSelectedModalAddress(validatedSuggestedAddress);
    } else {
      setSelectedModalAddress(typedAddress);
    }
  }

  const parseAddress = (address) => {
    let newAddress = address.filter((item) => item && item.length !== 0);
    return newAddress.join(", ");
  }

  return (
    <>
      <Heading>Address Validation</Heading>
      <OptionsForm>
        <OptionsContainer onChange={onChangeValue}>
          {hasValidatedSuggestion &&
            <Option><RadioButton value={validatedSuggestedAddress} name="address" checked={selectedModalAddress == validatedSuggestedAddress}>
              <Address>
                <Title>Suggested Validated Address</Title>
                {validatedSuggestedAddress && <Body>{parseAddress(validatedSuggestedAddress)}</Body>}
              </Address>
            </RadioButton></Option>}
          <Option><RadioButton value={typedAddress} name="address" checked={selectedModalAddress == typedAddress}>
            <Address>
              <Title>Address You Entered</Title>
              <Body>
                {typedAddress}
              </Body>
            </Address>
          </RadioButton></Option>
        </OptionsContainer>
        <FormButton onClick={(event) => handleClick(event)}>Save Selection</FormButton>
      </OptionsForm>
    </>
  );
};

export default ValidatedAddressSuggestionModal;
